(function () {
  'use strict';

  var ROOT_SELECTOR = '[data-qz-root]';
  var DRAFT_KEY = 'qz_draft_v1';
  var MAX_DRAFT_AGE_MS = 24 * 60 * 60 * 1000;
  var STATUS = { IN_PROGRESS: 'in_progress', COMPLETED: 'completed', OFFER_CLICKED: 'offer_clicked', PDP_REDIRECTED: 'pdp_redirected' };

  var reduceMotion = false;
  try { reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches; } catch (e) {}

  /* ---------------- utils ---------------- */

  function esc(str) {
    if (str === null || str === undefined) return '';
    return String(str).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function isPlainObject(v) { return !!v && typeof v === 'object' && !Array.isArray(v); }

  function deepMerge(a, b) {
    if (!isPlainObject(a)) a = {};
    if (!isPlainObject(b)) return a;
    var out = Object.assign({}, a);
    Object.keys(b).forEach(function (k) {
      if (b[k] === null || b[k] === undefined) return; // no override supplied - keep the base config's value
      out[k] = (isPlainObject(b[k]) && isPlainObject(a[k])) ? deepMerge(a[k], b[k]) : b[k];
    });
    return out;
  }

  function makeId() {
    if (window.crypto && typeof crypto.randomUUID === 'function') return crypto.randomUUID();
    var b = new Uint8Array(16);
    if (window.crypto && crypto.getRandomValues) crypto.getRandomValues(b);
    else for (var i = 0; i < 16; i++) b[i] = Math.floor(Math.random() * 256);
    b[6] = (b[6] & 0x0f) | 0x40;
    b[8] = (b[8] & 0x3f) | 0x80;
    var hex = Array.prototype.map.call(b, function (x) { return x.toString(16).padStart(2, '0'); }).join('');
    return hex.slice(0, 8) + '-' + hex.slice(8, 12) + '-' + hex.slice(12, 16) + '-' + hex.slice(16, 20) + '-' + hex.slice(20);
  }

  function fetchWithTimeout(url, opts, ms) {
    var ctrl = (typeof AbortController !== 'undefined') ? new AbortController() : null;
    var t = ctrl ? setTimeout(function () { ctrl.abort(); }, ms) : null;
    var merged = Object.assign({}, opts, ctrl ? { signal: ctrl.signal } : {});
    return fetch(url, merged).finally(function () { if (t) clearTimeout(t); });
  }

  function clamp(n, lo, hi) { return Math.max(lo, Math.min(hi, n)); }

  /* ---------------- inline icons ---------------- */

  var BATTERY_LEVELS = { 'battery-0': 0, 'battery-1': 1, 'battery-2': 2, 'battery-3': 3 };

  var BATTERY_COLORS = ['#FF3B30', '#FF7A1A', '#FFC72C', '#3DD65C'];

  function batteryIcon(level) {
    var color = BATTERY_COLORS[clamp(level, 0, 3)];
    var fills = [0, 1, 2, 3].map(function (i) {
      var on = i < level;
      return '<rect x="' + (4 + i * 4) + '" y="8" width="3" height="8" rx="0.5" fill="' + (on ? color : 'rgba(255,255,255,.15)') + '" stroke="' + (on ? color : 'rgba(255,255,255,.35)') + '" stroke-width="1"/>';
    }).join('');
    return '<svg viewBox="0 0 26 24" width="28" height="24" aria-hidden="true" focusable="false">' +
      '<rect x="2" y="6" width="19" height="12" rx="2.5" fill="none" stroke="currentColor" stroke-width="1.6"/>' +
      '<rect x="22" y="10" width="2.5" height="4" rx="1" fill="currentColor"/>' +
      fills + '</svg>';
  }

  function lineIcon(name) {
    var paths = {
      shield: '<path d="M12 2.5 4.5 5.5v5.2c0 4.7 3.2 8.9 7.5 10.3 4.3-1.4 7.5-5.6 7.5-10.3V5.5L12 2.5Z" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linejoin="round"/><path d="m8.7 12 2.3 2.3 4.3-4.6" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>',
      lock: '<rect x="5" y="10.5" width="14" height="9.5" rx="1.8" fill="none" stroke="currentColor" stroke-width="1.5"/><path d="M8 10.5V8a4 4 0 0 1 8 0v2.5" fill="none" stroke="currentColor" stroke-width="1.5"/>',
      heart: '<path d="M12 20s-7-4.3-9.3-8.8C1.2 8 3 5 6.3 5c1.9 0 3.4 1 4.7 2.6C12.3 6 13.8 5 15.7 5 19 5 20.8 8 19.3 11.2 17 15.7 12 20 12 20Z" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linejoin="round"/>',
      box: '<path d="M3.5 8.2 12 4l8.5 4.2v8.1L12 20.5 3.5 16.3V8.2Z" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linejoin="round"/><path d="M3.7 8.4 12 12.4l8.3-4M12 12.4v8.1" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linejoin="round"/>'
    };
    return '<svg viewBox="0 0 24 24" width="20" height="20" aria-hidden="true" focusable="false">' + (paths[name] || paths.shield) + '</svg>';
  }

  var CHECK_ICON = '<svg class="qz-check-row__check" viewBox="0 0 20 20" aria-hidden="true" focusable="false"><path d="M4 10.5 8 14l8-9" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"/></svg>';
  var CHECK_SMALL = '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M4 12.5l5 5L20 6.5" fill="none" stroke="currentColor" stroke-width="2.6" stroke-linecap="round" stroke-linejoin="round"/></svg>';
  var GRAD_DEFS = '<defs><linearGradient id="qz-grad" x1="0" y1="0" x2="1" y2="1"><stop offset="0" stop-color="#FF3035"/><stop offset="1" stop-color="#C92323"/></linearGradient></defs>';

  // Solid glyphs shared with the mm15 "What to expect" milestones (sections/mm15-expect.liquid).
  function solidIcon(name) {
    var p = {
      bolt: 'M13 2 4 14h7l-1 8 9-12h-7z',
      burst: 'M22 12l-5.84 1.72 2.91 5.35-5.35-2.91L12 22l-1.72-5.84-5.35 2.91 2.91-5.35L2 12l5.84-1.72-2.91-5.35 5.35 2.91L12 2l1.72 5.84 5.35-2.91-2.91 5.35z',
      rocket: 'M21 3c-4.5 0-8.4 2-11 5.2L6.6 8l-3 3 3.4.9 4.1 4.1.9 3.4 3-3-.2-3.4C18.9 11.4 21 7.5 21 3zm-6 5a1.6 1.6 0 1 1 0 3.2A1.6 1.6 0 0 1 15 8zM6 15c-1.7 0-3 1.3-3 3v3h3c1.7 0 3-1.3 3-3l-1.5-1.5L6 15z',
      dumbbell: 'M2 9h2V7h3v10H4v-2H2V9zm20 0h-2V7h-3v10h3v-2h2V9zM9 10h6v4H9z',
      heart: 'M12 21s-8-5-8-11a4.5 4.5 0 0 1 8-2.8A4.5 4.5 0 0 1 20 10c0 6-8 11-8 11z',
      flag: 'M5 2h2v20H5V2zm3 1h11l-2 4 2 4H8V3z',
      clock: 'M12 2a10 10 0 1 0 0 20 10 10 0 0 0 0-20zm1 5v4.6l3.5 2-1 1.7L11 13V7h2z',
      shield: 'M12 3l8 3v6c0 5-3.5 8-8 9-4.5-1-8-4-8-9V6l8-3zm-1.2 12.3 5.6-5.6-1.4-1.4-4.2 4.2-2-2-1.4 1.4 3.4 3.4z'
    };
    return '<svg viewBox="0 0 24 24" fill="currentColor" fill-rule="evenodd" aria-hidden="true" focusable="false"><path d="' + (p[name] || p.bolt) + '"/></svg>';
  }

  function countUp(el, to, ms, track, suffix) {
    var start = null;
    function frame(ts) {
      if (!start) start = ts;
      var p = clamp((ts - start) / ms, 0, 1);
      var eased = 1 - Math.pow(1 - p, 3);
      el.textContent = Math.round(to * eased) + (suffix || '');
      if (p < 1) track(requestAnimationFrame(frame));
    }
    track(requestAnimationFrame(frame));
  }

  /* ---------------- config ---------------- */

  function ui(cfg, key, fallback) { return (cfg.ui && cfg.ui[key]) || fallback; }

  function loadConfig(url, overrides) {
    return fetch(url, { credentials: 'omit' })
      .then(function (r) { return r.ok ? r.json() : {}; })
      .catch(function () { return {}; })
      .then(function (base) { return deepMerge(base, overrides || {}); });
  }

  function getTestimonial(cfg) {
    var fromScreen = null;
    (cfg.screens || []).some(function (s) { if (s.testimonial) { fromScreen = s.testimonial; return true; } return false; });
    return deepMerge(fromScreen || {}, cfg.testimonial || {});
  }

  /* ---------------- draft persistence ---------------- */

  function loadDraft() {
    try {
      var raw = sessionStorage.getItem(DRAFT_KEY);
      if (!raw) return null;
      var d = JSON.parse(raw);
      if (!d.savedAt || Date.now() - d.savedAt > MAX_DRAFT_AGE_MS) return null;
      return d;
    } catch (e) { return null; }
  }

  function saveDraft(state) {
    try {
      sessionStorage.setItem(DRAFT_KEY, JSON.stringify({
        sessionId: state.sessionId, revision: state.revision, status: state.status,
        answers: state.answers, attribution: state.attribution, consent: state.consent,
        resumeIndex: state.resumeIndex, savedAt: Date.now()
      }));
    } catch (e) {}
  }

  function clearDraft() { try { sessionStorage.removeItem(DRAFT_KEY); } catch (e) {} }

  function captureAttribution() {
    var p = new URLSearchParams(location.search);
    return {
      utm_source: p.get('utm_source'), utm_medium: p.get('utm_medium'),
      utm_campaign: p.get('utm_campaign'), utm_term: p.get('utm_term'),
      utm_content: p.get('utm_content'), entry_utm_content: p.get('entry_utm_content')
    };
  }

  /* ---------------- networking ---------------- */

  var net = { timer: null, retries: 0 };

  function snapshotBody(state, cfg) {
    return {
      id: state.sessionId, quiz_version: cfg.quiz_version, revision: state.revision,
      status: state.status, last_screen: state.currentScreenId, answers: state.answers,
      attribution: state.attribution, consent_version: state.consent.version, consent_at: state.consent.at
    };
  }

  function apiBase(cfg) {
    var b = cfg.api_base_url;
    return (typeof b === 'string' && b.trim()) ? b.replace(/\/+$/, '') : '';
  }

  function submitSnapshot(state, cfg, opts) {
    opts = opts || {};
    var base = apiBase(cfg);
    if (!base) return Promise.resolve({ ok: false, skipped: true });
    return fetchWithTimeout(base + '/api/quiz/responses', {
      method: 'POST', credentials: 'include', headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(snapshotBody(state, cfg))
    }, opts.timeout || 6000).then(function (res) {
      net.retries = 0;
      if (!res.ok && res.status !== 409) throw new Error('http_' + res.status);
      return { ok: true, status: res.status };
    }).catch(function (err) {
      if (opts.oneShot) throw err;
      if (net.retries < 3) {
        net.retries++;
        var delay = [1000, 3000, 8000][net.retries - 1];
        setTimeout(function () { submitSnapshot(state, cfg); }, delay);
      }
      return { ok: false };
    });
  }

  function scheduleSubmit(state, cfg) {
    clearTimeout(net.timer);
    net.timer = setTimeout(function () { submitSnapshot(state, cfg); }, 400);
  }

  function flushBeacon(state, cfg) {
    var base = apiBase(cfg);
    if (!base) return;
    var body = JSON.stringify(snapshotBody(state, cfg));
    try {
      if (navigator.sendBeacon) {
        navigator.sendBeacon(base + '/api/quiz/responses', new Blob([body], { type: 'application/json' }));
      } else {
        fetch(base + '/api/quiz/responses', { method: 'POST', body: body, headers: { 'Content-Type': 'application/json' }, keepalive: true, credentials: 'include' });
      }
    } catch (e) {}
  }

  /* ---------------- PDP handoff URL ---------------- */

  function isAllowedPdpPath(p) {
    return typeof p === 'string' && /^\/products\/[a-zA-Z0-9\-_%]+$/.test(p.split('?')[0]);
  }

  function buildPdpUrl(cfg) {
    var pdpPath = cfg.offer && cfg.offer.pdp_url;
    if (!isAllowedPdpPath(pdpPath)) return null;
    var out = new URL(pdpPath, location.origin);
    var incoming = new URLSearchParams(location.search);
    ['utm_source', 'utm_medium', 'utm_campaign', 'utm_term'].forEach(function (k) {
      var v = incoming.get(k); if (v) out.searchParams.set(k, v);
    });
    var creative = incoming.get('entry_utm_content') || incoming.get('utm_content');
    if (creative && creative !== 'quiz') out.searchParams.set('entry_utm_content', creative);
    out.searchParams.set('utm_content', 'quiz');
    out.searchParams.set('quiz_offer', '1');
    var path = out.pathname + '?' + out.searchParams.toString();
    var code = cfg.offer && cfg.offer.discount_code;
    if (code) path = '/discount/' + encodeURIComponent(code) + '?redirect=' + encodeURIComponent(path);
    return path;
  }

  /* ---------------- app ---------------- */

  function boot(root) {
    var configUrl = root.getAttribute('data-config-url');
    var overrides = window.__QUIZ_OVERRIDES__ || {};
    var logoEl = root.querySelector('[data-qz-logo]');
    var progressEl = root.querySelector('[data-qz-progress]');
    var progressFillEl = root.querySelector('[data-qz-progress-fill]');
    var mainEl = root.querySelector('[data-qz-main]');

    loadConfig(configUrl, overrides).then(function (cfg) {
      cfg.api_base_url = overrides.api_base_url || '';

      var screens = cfg.screens || [];
      var questionsById = {};
      (cfg.questions || []).forEach(function (q) { questionsById[q.id] = q; });

      var draft = loadDraft();
      var freshAttribution = captureAttribution();
      var state = draft ? {
        sessionId: draft.sessionId,
        revision: draft.revision || 0,
        status: draft.status || STATUS.IN_PROGRESS,
        answers: draft.answers && draft.answers.length === (cfg.question_order || []).length ? draft.answers : (cfg.question_order || []).map(function () { return null; }),
        attribution: draft.attribution || freshAttribution,
        consent: draft.consent || { version: null, at: null },
        resumeIndex: draft.resumeIndex || 0,
        currentScreenId: null
      } : {
        sessionId: makeId(),
        revision: 0,
        status: STATUS.IN_PROGRESS,
        answers: (cfg.question_order || []).map(function () { return null; }),
        attribution: freshAttribution,
        consent: { version: null, at: null },
        resumeIndex: 0,
        currentScreenId: null
      };

      renderLogo(logoEl, cfg);

      var currentIndex = -1;
      var activeTimers = [];
      function trackTimer(id) { activeTimers.push(id); return id; }
      function clearScreenTimers() {
        // setTimeout and requestAnimationFrame ids are separate counters, but
        // calling the "wrong" cancel function for an id is a harmless no-op,
        // so one list can safely hold both kinds.
        activeTimers.forEach(function (id) { clearTimeout(id); cancelAnimationFrame(id); });
        activeTimers = [];
      }

      function answerIndex(questionId) { return (cfg.question_order || []).indexOf(questionId); }

      function updateProgress(idx) {
        var total = screens.length;
        var pct = total > 1 ? Math.round(((idx + 1) / total) * 100) : 0;
        if (idx <= 0) { progressEl.hidden = true; return; }
        progressEl.hidden = false;
        progressFillEl.style.width = pct + '%';
      }

      function stampConsent() {
        if (!state.consent.at) {
          state.consent.version = cfg.quiz_version;
          state.consent.at = new Date().toISOString();
        }
      }

      function persist() {
        saveDraft(state);
        scheduleSubmit(state, cfg);
      }

      function recomputeStatus() {
        var allAnswered = state.answers.every(function (a) { return a !== null && a !== undefined; });
        if (allAnswered && state.status === STATUS.IN_PROGRESS) state.status = STATUS.COMPLETED;
      }

      function goTo(idx, opts) {
        opts = opts || {};
        clearScreenTimers();
        idx = clamp(idx, 0, screens.length - 1);
        var screen = screens[idx];
        currentIndex = idx;
        state.currentScreenId = screen.id;
        // Track the CURRENTLY displayed screen (not the furthest ever reached) so
        // that Back-then-refresh resumes where the visitor actually is, not
        // wherever they'd gotten to before going back.
        state.resumeIndex = idx;

        mainEl.innerHTML = renderScreen(screen, cfg, questionsById, state, answerIndex);
        mainEl.querySelectorAll('.qz-screen > *').forEach(function (el, i) { el.style.setProperty('--i', String(i)); });
        wireScreen(screen, mainEl, cfg, questionsById, state, {
          answerIndex: answerIndex, goNext: function () { goTo(currentIndex + 1); },
          persist: persist, stampConsent: stampConsent, recomputeStatus: recomputeStatus,
          finishAndRedirect: finishAndRedirect, trackTimer: trackTimer
        });

        updateProgress(idx);

        var heading = mainEl.querySelector('h1');
        if (heading) { heading.setAttribute('tabindex', '-1'); heading.focus({ preventScroll: true }); }
        window.scrollTo(0, 0);

        if (!opts.fromHistory) {
          var method = opts.replace ? 'replaceState' : 'pushState';
          history[method]({ qzIndex: idx }, '', '#' + screen.id);
        }

        saveDraft(state);
      }

      function finishAndRedirect(rowEls, footerEls) {
        var appliedKey = 'qz_applied_' + state.sessionId;
        var already = false;
        try { already = sessionStorage.getItem(appliedKey) === '1'; } catch (e) {}

        var url = buildPdpUrl(cfg);
        var rows = rowEls;

        function markDone(i) { if (rows[i]) rows[i].classList.add('is-done'); }
        function markActive(i) { if (rows[i]) rows[i].classList.add('is-active'); }

        function showRetry() {
          footerEls.retry.hidden = false;
          footerEls.continueLink.href = url || (cfg.offer && cfg.offer.pdp_url) || '/';
        }

        if (!url) { showRetry(); return; }

        if (already) {
          rows.forEach(function (_, i) { markActive(i); markDone(i); });
          location.href = url;
          return;
        }

        var delays = [250, 550, 850];
        rows.forEach(function (_, i) { trackTimer(setTimeout(function () { markActive(i); markDone(i); }, reduceMotion ? 40 * i : delays[i])); });

        state.status = STATUS.OFFER_CLICKED;
        persist();

        var lastRowDelay = reduceMotion ? 160 : 1150;
        trackTimer(setTimeout(function () {
          markActive(3);
          state.status = STATUS.PDP_REDIRECTED;
          submitSnapshot(state, cfg, { timeout: 3000 }).then(function (res) {
            if (res && (res.ok || res.skipped)) {
              markDone(3);
              try { sessionStorage.setItem(appliedKey, '1'); } catch (e) {}
              saveDraft(state);
              clearDraft();
              trackTimer(setTimeout(function () { location.href = url; }, reduceMotion ? 60 : 400));
            } else {
              showRetry();
            }
          });
        }, lastRowDelay));
      }

      window.addEventListener('popstate', function (e) {
        var idx = e.state && typeof e.state.qzIndex === 'number' ? e.state.qzIndex : screenIndexFromHash();
        if (idx == null) idx = 0;
        goTo(idx, { fromHistory: true });
      });

      function screenIndexFromHash() {
        var id = location.hash.replace('#', '');
        var i = screens.findIndex(function (s) { return s.id === id; });
        return i >= 0 ? i : null;
      }

      document.addEventListener('visibilitychange', function () {
        if (document.visibilityState === 'hidden') flushBeacon(state, cfg);
      });

      var startIndex = clamp(state.resumeIndex, 0, screens.length - 1);
      goTo(startIndex, { replace: true });
    });
  }

  /* ---------------- rendering ---------------- */

  function renderLogo(logoEl, cfg) {
    var logoUrl = cfg.assets && cfg.assets.logo_url;
    if (logoUrl) {
      logoEl.innerHTML = '<img src="' + esc(logoUrl) + '" alt="' + esc(cfg.brand_label || '') + '">';
    } else {
      logoEl.innerHTML = '<span class="qz-logo__text">' + esc(cfg.brand_label || '') + '</span>';
    }
  }

  function optionsMarkup(question, groupName, selectedCode) {
    return '<div class="qz-options" role="radiogroup" data-qz-options>' +
      question.options.map(function (opt, i) {
        var checked = selectedCode !== null && selectedCode !== undefined && String(selectedCode) === String(opt.code);
        var icon = opt.icon && BATTERY_LEVELS.hasOwnProperty(opt.icon) ? '<span class="qz-opt__icon">' + batteryIcon(BATTERY_LEVELS[opt.icon]) + '</span>' : '';
        return '<label class="qz-opt qz-glass' + (checked ? ' is-selected' : '') + '" data-qz-opt data-code="' + esc(opt.code) + '">' +
          '<input class="qz-sr-only" type="radio" name="' + esc(groupName) + '" value="' + esc(opt.code) + '"' + (checked ? ' checked' : '') + '>' +
          '<span class="qz-opt__dot" aria-hidden="true">' + CHECK_SMALL + '</span>' +
          icon + '<span class="qz-opt__label">' + esc(opt.label) + '</span></label>';
      }).join('') + '</div>';
  }

  function renderScreen(screen, cfg, questionsById, state, answerIndex) {
    switch (screen.type) {
      case 'question': return renderQuestion(screen, cfg, questionsById, state, answerIndex);
      case 'gif_interstitial': return renderGif(screen, cfg);
      case 'progress': return renderProgress(screen, cfg);
      case 'checklist': return renderChecklist(screen, cfg);
      case 'result': return renderResult(screen, cfg, state, answerIndex, questionsById);
      case 'projection': return renderProjection(screen, cfg);
      case 'offer': return renderOffer(screen, cfg);
      case 'offer_handoff': return renderHandoff(screen, cfg);
      default: return '';
    }
  }

  function testimonialMarkup(t) {
    return '<div class="qz-testimonial qz-glass">' +
      '<div class="qz-testimonial__avatar">' + (t.avatar_url ? '<img src="' + esc(t.avatar_url) + '" alt="">' : '“') + '</div>' +
      '<div><p class="qz-testimonial__quote">“' + esc(t.quote) + '”</p>' +
      '<span class="qz-testimonial__by">' + esc(t.attribution || '') + '</span>' +
      (t.sample_only ? '<span class="qz-testimonial__sample">Sample testimonial — replace before launch.</span>' : '') +
      '</div></div>';
  }

  function renderQuestion(screen, cfg, questionsById, state, answerIndex) {
    var q = questionsById[screen.question_id];
    var idx = answerIndex(q.id);
    var selected = state.answers[idx];
    var isFirst = !!screen.testimonial;
    var testimonial = isFirst ? getTestimonial(cfg) : null;

    var html = '<section class="qz-screen" data-qz-screen="' + esc(screen.id) + '">';
    if (screen.title) {
      html += '<h1 class="qz-h1">' + esc(screen.title) + '</h1>';
      if (screen.description) html += '<p class="qz-body">' + esc(screen.description) + '</p>';
      if (testimonial && testimonial.quote) html += testimonialMarkup(testimonial);
      html += '<h2 class="qz-h1" style="font-size:clamp(20px,4.4vw,28px);">' + esc(q.prompt) + '</h2>';
    } else {
      html += '<h1 class="qz-h1">' + esc(q.prompt) + '</h1>';
      if (screen.description) html += '<p class="qz-body">' + esc(screen.description) + '</p>';
    }
    html += optionsMarkup(q, 'qz-' + q.id, selected);
    if (screen.note_title && screen.note) {
      html += '<div class="qz-note qz-glass"><div><p class="qz-caption" style="margin-bottom:6px;">' + esc(screen.note_title) + '</p>' +
        '<p class="qz-body" style="color:#cfcfcf;">' + esc(screen.note) + '</p></div></div>';
    }
    if (isFirst) {
      html += '<p class="qz-disclosure qz-consent">' + esc(ui(cfg, 'consent_before', 'By continuing you agree to receive a personalized result based on your answers. See our')) + ' <a href="' + esc(cfg.privacy_policy_url || '/policies/privacy-policy') + '">' + esc(ui(cfg, 'privacy_link', 'Privacy Policy')) + '</a>. ' + esc(ui(cfg, 'consent_after', 'We use your answers only to personalize this quiz.')) + '</p>';
    }
    html += '</section>';
    return html;
  }

  function renderGif(screen, cfg) {
    var url = cfg.assets && cfg.assets[screen.asset_key];
    var poster = cfg.assets && cfg.assets.right_place_poster_url;
    var showUrl = reduceMotion ? (poster || null) : (url || poster || null);
    return '<section class="qz-screen" data-qz-screen="' + esc(screen.id) + '">' +
      '<h1 class="qz-h1">' + esc(screen.title) + '</h1>' +
      (screen.description ? '<p class="qz-body">' + esc(screen.description) + '</p>' : '') +
      '<div class="qz-media qz-glass"' + (showUrl ? '' : ' hidden') + '>' + (showUrl ? '<img src="' + esc(showUrl) + '" alt="" loading="eager">' : '') + '</div>' +
      '<button type="button" class="qz-btn" data-qz-continue>' + esc(screen.cta || 'CONTINUE') + '</button>' +
      '</section>';
  }

  function renderProgress(screen, cfg) {
    return '<section class="qz-screen" data-qz-screen="' + esc(screen.id) + '">' +
      '<h1 class="qz-h1">' + esc(screen.title) + '</h1>' +
      (screen.description ? '<p class="qz-body">' + esc(screen.description) + '</p>' : '') +
      '<div class="qz-ring-wrap"><svg class="qz-ring" viewBox="0 0 140 140" role="img" aria-label="' + esc(screen.caption || 'Analyzing') + '">' + GRAD_DEFS +
      '<circle class="qz-ring__track" cx="70" cy="70" r="60"/>' +
      '<circle class="qz-ring__fill" data-qz-ring cx="70" cy="70" r="60" stroke-dasharray="376.99" stroke-dashoffset="376.99"/>' +
      '<text class="qz-ring__label" data-qz-ring-label x="70" y="72">0%</text>' +
      '</svg></div>' +
      '<p class="qz-caption" style="text-align:center;">' + esc(screen.caption || '') + '</p>' +
      '</section>';
  }

  function checklistRows(items, brown) {
    return '<ul class="qz-checklist" data-qz-rows>' + items.map(function (label, i) {
      return '<li class="qz-check-row qz-glass' + (brown ? ' qz-check-row--brown' : '') + '" data-qz-row="' + i + '">' +
        '<span class="qz-check-row__icon">' + lineIcon(brown ? ['shield', 'lock', 'heart', 'box'][i] : 'shield') + '</span>' +
        '<span class="qz-check-row__label">' + esc(label) + '</span>' + CHECK_ICON + '</li>';
    }).join('') + '</ul>';
  }

  function renderChecklist(screen, cfg) {
    return '<section class="qz-screen" data-qz-screen="' + esc(screen.id) + '">' +
      '<h1 class="qz-h1">' + esc(screen.title) + '</h1>' +
      (screen.description ? '<p class="qz-body">' + esc(screen.description) + '</p>' : '') +
      checklistRows(screen.items || [], false) +
      (screen.caption ? '<p class="qz-caption" style="text-align:center;">' + esc(screen.caption) + '</p>' : '') +
      '</section>';
  }

  function answerLabel(questionsById, qId, code) {
    var q = questionsById[qId];
    if (!q || code === null || code === undefined) return '—';
    var opt = q.options.filter(function (o) { return String(o.code) === String(code); })[0];
    return opt ? opt.label : '—';
  }

  function renderResult(screen, cfg, state, answerIndex, questionsById) {
    var labels = screen.card_labels || {};
    var keyToQid = { concern: 'q2', afternoon_energy: 'q4', onset: 'q5', desired_result: 'q6' };
    var tileIcon = { concern: 'bolt', onset: 'clock', desired_result: 'rocket' };
    var tiles = Object.keys(labels).map(function (key, i) {
      var qid = keyToQid[key];
      var code = state.answers[answerIndex(qid)];
      // Energy tile reuses the battery glyph at the level the visitor actually picked.
      var icon = key === 'afternoon_energy' && code !== null && code !== undefined
        ? batteryIcon(3 - clamp(Number(code), 0, 3))
        : solidIcon(tileIcon[key] || 'bolt');
      return '<div class="qz-tile qz-glass" style="--i:' + i + '"><span class="qz-tile__icon">' + icon + '</span>' +
        '<span><span class="qz-tile__label">' + esc(labels[key]) + '</span>' +
        '<span class="qz-tile__value">' + esc(answerLabel(questionsById, qid, code)) + '</span></span></div>';
    }).join('');
    var meterValue = clamp(screen.meter_value != null ? screen.meter_value : 100, 0, 100);
    // 270° arc on r=74: circumference 464.96, sweep 348.72; rotated so the gap sits at the bottom.
    return '<section class="qz-screen" data-qz-screen="' + esc(screen.id) + '">' +
      '<h1 class="qz-h1">' + esc(screen.title || 'YOUR QUIZ SUMMARY') + '</h1>' +
      (screen.description ? '<p class="qz-body">' + esc(screen.description) + '</p>' : '') +
      '<div class="qz-result qz-glass">' +
      '<div class="qz-gauge" role="img" aria-label="' + esc(screen.meter_title || '') + ' ' + meterValue + '%">' +
      '<svg viewBox="0 0 184 184">' + GRAD_DEFS +
      '<g transform="rotate(135 92 92)">' +
      '<circle class="qz-gauge__track" cx="92" cy="92" r="74" stroke-dasharray="348.72 464.96"/>' +
      '<circle class="qz-gauge__fill" data-qz-gauge cx="92" cy="92" r="74" stroke-dasharray="348.72 464.96" stroke-dashoffset="348.72" data-target="' + meterValue + '"/>' +
      '</g></svg>' +
      '<div class="qz-gauge__center" aria-hidden="true"><div class="qz-gauge__num"><span data-qz-gauge-num>0</span><small>%</small></div>' +
      '<div class="qz-gauge__label">' + esc(screen.meter_title || '') + '</div></div>' +
      '</div>' +
      '<div class="qz-tiles">' + tiles + '</div>' +
      '</div>' +
      '<button type="button" class="qz-btn" data-qz-continue>' + esc(screen.cta || 'CONTINUE →') + '</button>' +
      '</section>';
  }

  function renderProjection(screen, cfg) {
    var phases = screen.phases || [];
    var defaultIcons = ['bolt', 'dumbbell', 'flag'];
    var nodes = phases.map(function (p, i) {
      return '<li class="qz-node' + (i === phases.length - 1 ? ' is-last' : '') + '" data-qz-node>' +
        '<span class="qz-node__week">' + esc(p.label) + '</span>' +
        '<span class="qz-node__dot">' + solidIcon(p.icon || defaultIcons[i] || 'bolt') + '</span>' +
        '<span class="qz-node__meta"><span class="qz-node__name">' + esc(p.sub) + '</span>' + (p.outcome ? '<span class="qz-node__outcome">' + esc(p.outcome) + '</span>' : '') + '</span></li>';
    }).join('');
    return '<section class="qz-screen" data-qz-screen="' + esc(screen.id) + '">' +
      '<h1 class="qz-h1">' + esc(screen.title) + '</h1>' +
      (screen.description ? '<p class="qz-body">' + esc(screen.description) + '</p>' : '') +
      '<div class="qz-rail qz-glass" data-qz-rail>' +
      '<div class="qz-rail__track" aria-hidden="true"><div class="qz-rail__fill"></div></div>' +
      '<ol class="qz-rail__nodes">' + nodes + '</ol>' +
      '<div class="qz-rail__foot"><span>' + esc(ui(cfg, 'day_start', 'Day 1')) + '</span><span>' + esc(ui(cfg, 'day_end', 'Day 90')) + '</span></div>' +
      '</div>' +
      (screen.disclosure ? '<p class="qz-disclosure">' + esc(screen.disclosure) + '</p>' : '') +
      '<button type="button" class="qz-btn" data-qz-continue>' + esc(screen.cta || 'CONTINUE →') + '</button>' +
      '</section>';
  }

  function renderOffer(screen, cfg) {
    var imgUrl = cfg.assets && cfg.assets[screen.asset_key];
    var bullets = (cfg.offer && cfg.offer.bullets && cfg.offer.bullets.length) ? cfg.offer.bullets : (screen.bullets || []);
    var badge = (cfg.offer && cfg.offer.badge_text) || 'Quiz discount';
    var showRefund = !cfg.offer || cfg.offer.show_refund_link !== false;
    var guaranteeDays = cfg.offer && cfg.offer.guarantee_days;
    return '<section class="qz-screen" data-qz-screen="' + esc(screen.id) + '">' +
      '<h1 class="qz-h1">' + esc(screen.title) + '</h1>' +
      (screen.description ? '<p class="qz-body">' + esc(screen.description) + '</p>' : '') +
      '<div class="qz-offer">' +
      '<div class="qz-offer__image qz-glass"' + (imgUrl ? '' : ' hidden') + '>' + (imgUrl ? '<img src="' + esc(imgUrl) + '" alt="">' : '') + '</div>' +
      '<span class="qz-badge">' + esc(badge) + '</span>' +
      '<ul class="qz-offer__bullets">' + bullets.map(function (b) { return '<li class="qz-glass">' + CHECK_SMALL + esc(b) + '</li>'; }).join('') + '</ul>' +
      (showRefund ? '<p class="qz-offer__guarantee">' + solidIcon('shield') + '<span>' + (cfg.ui && cfg.ui.guarantee_before ? esc(cfg.ui.guarantee_before.split('{days}').join(guaranteeDays || '')) : 'Backed by our' + (guaranteeDays ? ' ' + esc(guaranteeDays) + '-day' : '') + ' money-back guarantee. See our') + ' <a href="' + esc(cfg.refund_policy_url || '/policies/refund-policy') + '">' + esc(ui(cfg, 'refund_link', 'refund policy')) + '</a>.</span></p>' : '') +
      '</div>' +
      '<button type="button" class="qz-btn" data-qz-continue>' + esc(screen.cta || 'CONTINUE →') + '</button>' +
      '</section>';
  }

  function renderHandoff(screen, cfg) {
    return '<section class="qz-screen" data-qz-screen="' + esc(screen.id) + '">' +
      '<h1 class="qz-h1">' + esc(screen.title) + '</h1>' +
      (screen.description ? '<p class="qz-body">' + esc(screen.description) + '</p>' : '') +
      checklistRows(screen.items || [], true) +
      '<div class="qz-retry" data-qz-retry hidden>' +
      '<button type="button" class="qz-btn" data-qz-retry-btn>' + esc(ui(cfg, 'retry', 'Retry')) + '</button>' +
      '<a class="qz-btn qz-btn--ghost" data-qz-continue-link href="#">' + esc(ui(cfg, 'continue_to_product', 'Continue to product')) + '</a>' +
      '</div>' +
      (screen.caption ? '<p class="qz-checklist-footer">' + esc(screen.caption) + '</p>' : '') +
      '</section>';
  }

  /* ---------------- wiring (event listeners per screen) ---------------- */

  function wireScreen(screen, mainEl, cfg, questionsById, state, ctx) {
    if (screen.type === 'question') {
      var optionsWrap = mainEl.querySelector('[data-qz-options]');
      var q = questionsById[screen.question_id];
      var idx = ctx.answerIndex(q.id);
      optionsWrap.addEventListener('change', function (e) {
        if (e.target && e.target.type === 'radio') {
          var code = e.target.value;
          var opt = q.options.filter(function (o) { return String(o.code) === String(code); })[0];
          state.answers[idx] = opt ? opt.code : Number(code);
          ctx.stampConsent();
          ctx.recomputeStatus();
          optionsWrap.querySelectorAll('[data-qz-opt]').forEach(function (label) {
            label.classList.toggle('is-selected', label.querySelector('input').checked);
          });
          ctx.persist();
          ctx.trackTimer(setTimeout(ctx.goNext, reduceMotion ? 0 : 180));
        }
      });
    }

    if (screen.type === 'gif_interstitial' || screen.type === 'projection' || screen.type === 'result') {
      var btn = mainEl.querySelector('[data-qz-continue]');
      if (btn) btn.addEventListener('click', ctx.goNext);
    }

    if (screen.type === 'offer') {
      var obtn = mainEl.querySelector('[data-qz-continue]');
      if (obtn) obtn.addEventListener('click', function () {
        state.status = 'offer_clicked';
        ctx.persist();
        ctx.goNext();
      });
    }

    if (screen.type === 'progress') {
      var ring = mainEl.querySelector('[data-qz-ring]');
      var ringLabel = mainEl.querySelector('[data-qz-ring-label]');
      var circumference = 376.99;
      var duration = reduceMotion ? 200 : 2400;
      var start = null;
      function frame(ts) {
        if (!start) start = ts;
        var p = clamp((ts - start) / duration, 0, 1);
        ring.style.strokeDashoffset = String(circumference * (1 - p));
        ringLabel.textContent = Math.round(p * 100) + '%';
        if (p < 1) ctx.trackTimer(requestAnimationFrame(frame));
        else ctx.trackTimer(setTimeout(ctx.goNext, reduceMotion ? 80 : 300));
      }
      ctx.trackTimer(requestAnimationFrame(frame));
    }

    if (screen.type === 'checklist') {
      var rows = mainEl.querySelectorAll('[data-qz-row]');
      var stepDelay = reduceMotion ? 90 : 620;
      rows.forEach(function (row, i) {
        ctx.trackTimer(setTimeout(function () { row.classList.add('is-active'); row.classList.add('is-done'); }, stepDelay * (i + 1)));
      });
      ctx.trackTimer(setTimeout(ctx.goNext, stepDelay * (rows.length + 1) + (reduceMotion ? 100 : 400)));
    }

    if (screen.type === 'result') {
      var arc = mainEl.querySelector('[data-qz-gauge]');
      var num = mainEl.querySelector('[data-qz-gauge-num]');
      if (arc && num) {
        var target = clamp(Number(arc.getAttribute('data-target')) || 0, 0, 100);
        var sweep = 348.72;
        var gaugeMs = reduceMotion ? 1 : 1200;
        var gStart = null;
        function gaugeFrame(ts) {
          if (!gStart) gStart = ts;
          var p = clamp((ts - gStart) / gaugeMs, 0, 1);
          var eased = 1 - Math.pow(1 - p, 3);
          arc.setAttribute('stroke-dashoffset', String(sweep * (1 - (target / 100) * eased)));
          if (p < 1) ctx.trackTimer(requestAnimationFrame(gaugeFrame));
        }
        ctx.trackTimer(setTimeout(function () {
          ctx.trackTimer(requestAnimationFrame(gaugeFrame));
          countUp(num, target, gaugeMs, ctx.trackTimer);
        }, reduceMotion ? 0 : 250));
      }
    }

    if (screen.type === 'projection') {
      var rail = mainEl.querySelector('[data-qz-rail]');
      var nodeEls = mainEl.querySelectorAll('[data-qz-node]');
      if (rail) {
        ctx.trackTimer(setTimeout(function () { rail.classList.add('is-run'); }, reduceMotion ? 0 : 300));
        nodeEls.forEach(function (n, i) {
          ctx.trackTimer(setTimeout(function () { n.classList.add('is-on'); }, reduceMotion ? 0 : 450 + i * 380));
        });
      }
    }

    if (screen.type === 'offer_handoff') {
      var handoffRows = Array.prototype.slice.call(mainEl.querySelectorAll('[data-qz-row]'));
      var retryWrap = mainEl.querySelector('[data-qz-retry]');
      var retryBtn = mainEl.querySelector('[data-qz-retry-btn]');
      var continueLink = mainEl.querySelector('[data-qz-continue-link]');
      ctx.finishAndRedirect(handoffRows, { retry: retryWrap, continueLink: continueLink });
      if (retryBtn) retryBtn.addEventListener('click', function () {
        retryWrap.hidden = true;
        handoffRows.forEach(function (r) { r.classList.remove('is-active', 'is-done'); });
        ctx.finishAndRedirect(handoffRows, { retry: retryWrap, continueLink: continueLink });
      });
    }
  }

  /* ---------------- init ---------------- */

  function init() {
    var root = document.querySelector(ROOT_SELECTOR);
    if (root) boot(root);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
